var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitle16X16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5812_6375)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_5812_6375)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5812_6375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 23.4989C5 25.7554 5.8087 27.9408 7.27147 29.6627C8.73424 31.3848 10.7679 32.525 13.0037 32.8812C15.2394 33.2375 17.5229 32.7862 19.4495 31.6105C21.376 30.4346 22.8269 28.6058 23.5285 26.4681C24.2301 24.3185 24.147 21.9907 23.2908 19.9003C22.4343 17.8102 20.8647 16.0881 18.8548 15.0549C16.8449 14.0217 14.5378 13.7367 12.3377 14.2474C10.1376 14.7579 8.19907 16.0406 6.85523 17.8577L14.5022 23.4871H5V23.4989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 23.4989C43 25.7554 42.1912 27.9408 40.7286 29.6627C39.2659 31.3848 37.2322 32.525 34.9964 32.8812C32.7606 33.2375 30.4773 32.7862 28.5505 31.6105C26.624 30.4346 25.1731 28.6058 24.4715 26.4681C23.7699 24.3185 23.853 21.9907 24.7092 19.9003C25.5657 17.8102 27.1353 16.0881 29.1452 15.0549C31.1551 14.0217 33.4622 13.7367 35.6623 14.2474C37.8625 14.7579 39.801 16.0406 41.1447 17.8577L33.4978 23.4871H43V23.4989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 28L27 30.9999L24.0001 34L21 30.9999L24.0001 28Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5812_6375",
    x: -25,
    y: -12,
    width: 98,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5812_6375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5812_6375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5812_6375",
    x1: 0.787746,
    y1: 0.752942,
    x2: 56.6724,
    y2: 18.4194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5812_6375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle16X16);
export default __webpack_public_path__ + "static/media/Title16x16.cde7d43b7eba50b72cf8b6316655c948.svg";
export { ForwardRef as ReactComponent };